<template>
  <page-outline :title="$t('orphan.orphans_details')">
    <template slot="pageContent">
      <b-row class="justify-content-start mb-5">
        <b-col cols="4" sm="3" md="2" xl="1">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
        <b-col class="ml-4" cols="4" sm="3" md="2" xl="1"  @click="getUser()">
          <b-button class="back-button">
            <i class="fa-solid fa-rotate-right fs-14px"></i>
          </b-button>
        </b-col>
      </b-row>


      <spinner v-if="activateSpinner"></spinner>
      <template v-else-if="Orphan">
        <div>
          <form-accordion :title="$t('orphan.details')" class="p-3 mb-5" :isTitleUpperCase="false">
            <b-row class="form-group">
              <b-col sm="4" class="mb-5" v-if="Orphan.Type !== ''">
                <form-read-group-label-input
                  :inputLabel="$t('orphan.type')" :inputValue="Orphan.Type">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="mb-5" v-if="Orphan.Reference !== ''">
                <form-read-group-label-input
                  :inputLabel="$t('orphan.reference')" :inputValue="Orphan.Reference">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="mb-5" v-if="Orphan.CreationDate !== ''">
                <form-read-group-label-input
                  :inputLabel="$t('orphan.creation_date')" :inputValue="getDateDay(Orphan.CreationDate)">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="mb-5" v-if="Orphan.CreationDate === '' || Orphan.Reference === '' || Orphan.CreationDate === ''">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="4" class="mb-5" v-if="Orphan.IdScore != ''">
                <form-read-group-label-input
                    :inputLabel="$t('orphan.id_score')" :inputValue="Orphan.IdScore">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="mb-5" v-if="Orphan.NameScore != ''">
                <form-read-group-label-input
                                             :inputLabel="$t('orphan.name_score')" :inputValue="Orphan.NameScore">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="mb-5" >
                <form-read-group-label-input v-if="Orphan.FirstName != '' && Orphan.LastName != '' && type == 'DDV'"
                                             :inputLabel="$t('orphan.name')" :inputValue="Orphan.FirstName+ ' ' + Orphan.LastName">
                </form-read-group-label-input>
                <form-read-group-label-input v-else
                                             :inputLabel="$t('orphan.name')" :inputValue="Orphan.CompanyName">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="mb-5" v-if="Orphan.IdScore == '' || Orphan.NameScore == ''">
              </b-col>
            </b-row>
          </form-accordion>
          <hr  class="mx-auto" />
<!--          <form-accordion :title="$t('tracking.response')" class="p-3 mb-5" :isTitleUpperCase="false">-->
<!--            <b-row class="form-group">-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.CreationDateRp2 != ''"-->
<!--                                             :inputLabel="$t('tracking.creation_date_response_2')" :inputValue="getDateDay(Orphan.CreationDateRp2)">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.IdScore != '' && type == 'DDV'"-->
<!--                    :inputLabel="$t('tracking.id_score')" :inputValue="Orphan.IdScore">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.NameScore != '' && type == 'DDV'"-->
<!--                    :inputLabel="$t('tracking.name_score')" :inputValue="Orphan.NameScore">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row class="form-group" v-if="type == 'DDD' && (Orphan.LastName != '' || Orphan.BirthName != '' || Orphan.FirstName != '') && Orphan.CompanyName == ''">-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.FirstName != ''"-->
<!--                    :inputLabel="$t('tracking.first_name')" :inputValue="Orphan.FirstName">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.LastName != ''"-->
<!--                    :inputLabel="$t('tracking.last_name')" :inputValue="Orphan.LastName">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.BirthName != ''"-->
<!--                    :inputLabel="$t('tracking.birth_name')" :inputValue="Orphan.BirthName">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row class="form-group" v-if="type == 'DDD' && Orphan.MarriedName != '' && Orphan.CompanyName == '' ">-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.MarriedName != ''"-->
<!--                    :inputLabel="$t('tracking.married_name')" :inputValue="Orphan.MarriedName">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row class="form-group" v-if="type == 'DDD' && Orphan.CompanyName != '' ">-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.CompanyName != ''"-->
<!--                                             :inputLabel="$t('tracking.company_name')" :inputValue="Orphan.CompanyName">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row class="form-group" v-if="type == 'DDD' && (Orphan.TVAIntracomm != '' || Orphan.Siren != '' || Orphan.Siret != '')">-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.TVAIntracomm != ''"-->
<!--                    :inputLabel="$t('tracking.tva_intracomm')" :inputValue="Orphan.TVAIntracomm">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.Siren != ''"-->
<!--                    :inputLabel="$t('tracking.siren')" :inputValue="Orphan.Siren">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col sm="4" class="mb-5">-->
<!--                <form-read-group-label-input v-if="Orphan.Siret != ''"-->
<!--                    :inputLabel="$t('tracking.siret')" :inputValue="Orphan.Siret">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row class="form-group">-->
<!--              <b-col sm="4" class="mb-5" v-for="history in Orphan.History.filter((e) => e.StatusCode != '')" :key="history.id">-->
<!--                <form-read-group-label-input-->
<!--                    :inputLabel="$t('tracking.status_code_error')" :inputValue="$t('tracking.error-status-'+history.StatusCode)">-->
<!--                </form-read-group-label-input>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </form-accordion>-->
        </div>
<!--        <hr  class="mx-auto" />-->
<!--        <div >-->
<!--          <form-accordion :title="$t('tracking.history')" class="p-3" :isTitleUpperCase="false">-->
<!--            <table class="table table-striped" v-if="Orphan.History && Orphan.History.length">-->
<!--              <tbody>-->
<!--              <tr>-->
<!--                <th class="text-center w-25">-->
<!--                  {{ $t('tracking.status') }}-->
<!--                </th>-->
<!--                <th class="text-center w-25">-->
<!--                  {{ $t('tracking.status_code') }}-->
<!--                </th>-->
<!--                <th class="text-center w-25">-->
<!--                  {{ $t('tracking.processing_date') }}-->
<!--                </th>-->
<!--                <th class="text-center w-25">-->
<!--                </th>-->
<!--              </tr>-->
<!--              <tr v-for="history in Orphan.History" :key="history.id">-->
<!--                <td class="text-center w-25">-->
<!--                  <div v-if="history.Status != ''">{{ $t('tracking.status-'+history.Status) }}</div>-->
<!--                </td>-->
<!--                <td class="text-center w-25">-->
<!--                  <div v-if="history.StatusCode != ''">{{ $t('tracking.error-status-'+history.StatusCode) }}</div>-->
<!--                </td>-->
<!--                <td class="text-center w-25">-->
<!--                  {{ getDate(history.DateTime) }}-->
<!--                </td>-->
<!--                <td class="text-center align-middle w-25">-->
<!--                  <div class="d-flex justify-content-center align-item-center" v-if="history.Status == 1 || history.Status == 10 || history.Status == 30 || history.Status == 45 || history.Status == 50">-->
<!--                    <div>-->
<!--                      <i class="fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue" @click="seeJson(history.IdMsg, 'historyOrphan', 'see')"></i>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                      <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeJson(history.IdMsg, 'historyOrphan', 'download')"></i>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </td>-->
<!--              </tr>-->
<!--              </tbody>-->
<!--            </table>-->
<!--          </form-accordion>-->
<!--        </div>-->

      </template>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {errorMessageAlert} from "@/helpers/alert";
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import moment from "moment";
import {DOMParser} from "xmldom";

export default {
  name: 'OrphanDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canUserDelete () {
      return this.$engine.rights.rightIs('usercompany_delete', true) || this.$engine.rights.rightIs('usercompany_delete_admin', true)
    },
    canUserEdit () {
      return this.$engine.rights.rightIs('usercompany_edit', true) || this.$engine.rights.rightIs('usercompany_edit_admin', true)
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return 'Details de l\'utilisateur'
    }
  },
  props: ['id', 'type'],
  data () {
    return {
      activateSpinner: false,
      returnUrl: '',
      Orphan: {}
    }
  },
  created () {
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur',
      // returnUrl: ''
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.getOrphan()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    isXML (str) {
      try {
        const parser = new DOMParser()
        const jsonDoc = parser.parseFromString(str, 'text/xml')
        return jsonDoc.documentElement.nodeName !== 'parsererror'
      } catch (e) {
        return false
      }
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isCSV (str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    seeJson (IdMsg, service, action) {
      let that = this
      const id = IdMsg
      let dataDetails = {}
      this.$engine.tracking
          .getJSON({service, id})
          .then((resp) => {
            if (resp.data) {
              dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
              dataDetails.type = service
              if (action === 'see') {
                that.$bus.emit('popup-json-details', dataDetails)
              } else {
                //download file
                let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
                if (this.isXML(data)){
                  const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.xml'
                  const blob = new Blob([data], { type: 'text/xml' })

                  downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
                  that.$f7.alert('', that.$i18n.t('common.xml_downloaded'))
                }
                if (this.isJSON(data)){
                  const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.json'
                  const blob = new Blob([data], { type: 'application/json' })

                  downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
                  that.$f7.alert('', that.$i18n.t('common.json_downloaded'))
                }
                if (this.isCSV(data)){
                  const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.csv'
                  const blob = new Blob([data], { type: 'text/csv' })

                  downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
                  that.$f7.alert('', that.$i18n.t('common.csv_downloaded'))
                }
              }
            }
          })
          .catch((error) => {
            errorMessageAlert(error, that)
          })
    },
    getDateDay (date) {
      return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
    },
    getDate (date) {
      return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss.SSS')
    },
    defineReturnURL () {
      this.returnUrl =  '/tracking/Orphan/NULL'
    },
    getOrphan () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdOrphan: this.id
      }
      that.$engine.orphan.getOrphans(
          filterConditions
      ).then(resp => {
        if (resp.data && resp.data.orphans && resp.data.orphans.length) {
          that.Orphan = resp.data.orphans[0]
        }
        this.activateSpinner = false
      }).catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    hasProfileTrad (profileName) {
      let trad = this.$i18n.t('rights.db_profiles.' + profileName)
      if (trad === ('rights.db_profiles.' + profileName)) {
        return profileName
      }
      return trad
    }
  }
}
</script>
